import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useVersions = (projectId) => {
  const fetchContext = useContext(FetchContext);

  return useQuery(["project", projectId.toString(), "versions"], async () => {
    const { data } = await fetchContext.authAxios.get(
      `/projects/${projectId}/versions`
    );
    return data;
  });
};
